import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function StickyMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling past the hero section (approx 600px)
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToContact = () => {
    document.getElementById('contact-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <AnimatePresence data-id="element-323">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 260,
      damping: 20
    }} className="fixed bottom-0 left-0 right-0 z-50 md:hidden bg-carbon/90 backdrop-blur-md border-t border-dark-border p-4 pb-safe flex flex-col items-center" style={{
      paddingBottom: 'max(1rem, env(safe-area-inset-bottom))'
    }} data-id="element-324">
          <button onClick={scrollToContact} className="block w-full bg-gradient-to-r from-[#F2B705] to-[#E5A800] text-carbon font-bold rounded-xl px-6 py-4 text-center tracking-wide shadow-[0_0_15px_rgba(242,183,5,0.3)]" data-id="element-325">
            VERIFICAR MI ZONA
          </button>
          <a href="https://calendar.app.google/PYPdcRoYne7QrNJA7" target="_blank" rel="noopener noreferrer" className="text-gold text-xs font-medium mt-2 hover:underline" data-id="element-326">
            O agenda directamente →
          </a>
        </motion.div>}
    </AnimatePresence>;
}